import { render, staticRenderFns } from "./kioskInformation.vue?vue&type=template&id=190d79f8"
import script from "./kioskInformation.vue?vue&type=script&lang=js"
export * from "./kioskInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports